// import UIkit
import UIkit from 'uikit';

// import JQUERY
import jQuery from "jquery";

// import aframe
import "aframe";
import "aframe-event-set-component";
import "aframe-template-component";
import 'aframe-cubemap-component';

// import aframe custom code
import "./aframe/js/aframe-yoga-layout";
import "./aframe/js/aframe-utilities";
import "./aframe/js/aframe-geometries";
import "./aframe/js/aframe-effects";
import "./aframe/js/aframe-position";
import "./aframe/js/aframe-modal";
//import "./aframe/js/aframe-html";
import "./aframe/js/aframe-html-dev";
import "./aframe/js/aframe-sky";
import "./aframe/js/aframe-tooltip";

// import aframe CSS
import "./aframe.scss";

import Vue from "vue";
import VueProfiler from 'vue-profiler';
import VueI18n from "vue-i18n";
import Application from "./aframe/vue/Application";

import {messages} from "./aframe/vue/i18n";

jQuery(document).ready(function ($) {

    const vueContainer = $('#vue-aframe-app');

    if (vueContainer.length > 0) {

        Vue.config.ignoredElements = [
            'a-scene',
            'a-entity',
            'a-camera',
            'a-box',
            'a-sky',
            'a-sphere',
            'a-cylinder',
            'a-plane',
            'a-assets',
            'a-yoga-layout',
            'a-image',
            'a-mixin',
            'a-circle',
            'a-video',
            'a-text',
            'a-html',
        ];
        Vue.config.devtools = true;
        Vue.config.debug  = true;
        Vue.config.performance   = true;
        // Vue.config.silent  = true;
        // Vue.config.productionTip = false;

        Vue.use(VueI18n);
        Vue.use(VueProfiler);

        const i18n = new VueI18n({
            locale: 'ja', // set locale
            messages, // set locale messages
        });

        new Vue({
            el: vueContainer[0],
            components: {Application},
            i18n
        });
    }
});

export {};